import clsx from 'clsx';

// Muestra el estado del empleado con colores acordes al tema de Sinamon
export function EstadoBadge({ estado }) {
  const styles = {
    ACTIVO: 'bg-emerald-500/10 text-emerald-500 border border-emerald-500/30',
    INACTIVO: 'bg-amber-500/10 text-amber-500 border border-amber-500/30',
    BAJA: 'bg-rose-500/10 text-rose-500 border border-rose-500/30',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide',
        'dark:text-slate-100 dark:border-transparent',
        styles[estado] || styles.ACTIVO,
      )}
    >
      {estado}
    </span>
  );
}

export default EstadoBadge;
